<template>
  <OverlayCard :close-button="false" width="m" data-test-id="kickout-lease-card">
    <template #title>
      {{ $t('licensing.kickoutLeaseCard.text.title') }}
    </template>

    <template #content>
      {{ $t('licensing.kickoutLeaseCard.text.main') }}
    </template>

    <template #footer>
      <Btn color="blue" size="medium" @click="clickHandler" data-test-id="kickout-lease-card__use-button">
        {{ $t('licensing.kickoutLeaseCard.text.action') }}
      </Btn>
    </template>
  </OverlayCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { refreshLoginToKickLease } from '@/license';

export default defineComponent({
  name: 'KickoutLeaseCard',

  methods: {
    clickHandler() {
      refreshLoginToKickLease();
    },
  },
});
</script>
